import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { CrmConversationsQuery } from '@upme/contracts';
import { CrmConversationsInbox } from '../../../features/crm/components/crm-conversations-inbox';
import { crmCitiesOptions, crmMessagingChannelsOptions } from '../../../features/crm/queries';

const searchSchema = CrmConversationsQuery.catch({ limit: 50 });

export const Route = createFileRoute('/_authenticated/crm/conversations')({
  staticData: { breadcrumb: 'Переписки' },
  validateSearch: searchSchema,
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(crmCitiesOptions()),
      context.queryClient.ensureQueryData(crmMessagingChannelsOptions()),
    ]);
  },
  component: ConversationsPage,
});

function ConversationsPage() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { data: cities } = useSuspenseQuery(crmCitiesOptions());

  return (
    <CrmConversationsInbox
      filters={search}
      cities={cities}
      onFiltersChange={(next) => {
        void navigate({ search: next });
      }}
    />
  );
}
